import moment from 'moment'
import Model from './interface/Model'
import Opportunity from './Opportunity'

export default class OpportunityAmountChange extends Model {
  protected api_settings = {
    save_mode: 'post',
    paths: {
      singular: 'opportunity_amount_change' as string | null,
      plural: 'opportunity_amount_changes' as string | null,
    },
  }

  public id: string = ''

  public temp_id: any = null

  public opportunity_id: string = ''

  public closed_at: string = ''

  public amount: number = 0

  public status: string = ''

  public revenue_details: any = {}

  public year = moment().year()

  public created_at: string = moment().format()

  public updated_at: string = moment().format()

  public delete_on_save: boolean = false

  private _opportunity: Opportunity = new Opportunity()

  public fresh() {
    let start = moment(this._opportunity.start_at)
    let end = moment(this._opportunity.end_at)

    let months = Array.from({ length: end.diff(start, 'months') + 1 }, (_, i) =>
      start.clone().add(i, 'months'))
    return months.reduce((acc: any, month: any) => {
      acc[month.format('MMM_YYYY')] = 0
      return acc
    }, {})
  }

  public get remainingMonths() {
    let months = this.fresh()
    let filtered = Object.keys(this.revenue_details).filter(key => months.hasOwnProperty(key))

    return filtered
  }

  public get remainingValue() {
    return (
      this.amount
      - Object.values(this.revenue_details).reduce((acc: number, month: any) => acc + month, 0)
    )
  }

  public get statusColor() {
    switch (this.status) {
      case 'won':
        return 'success'
      case 'lost':
        return 'danger'
      default:
        return 'secondary'
    }
  }

  public get revenueMap() {
    let base = this.revenue_details.detailed_revenue_distribution.month

    let ret = []

    for (let key of Object.keys(base)) {
      let month = moment(key, 'MMM_YYYY')
      let value = base[key]
      ret.push({
        date: month,
        month: month.format('MMMM YYYY'),
        value,
      })
    }

    // sort by date
    ret = ret.sort((a, b) => a.date.diff(b.date))
    return ret
  }

  public get years() {
    let start = moment(this._opportunity.start_at)
    let end = moment(this._opportunity.end_at)
    let years = Array.from({ length: end.diff(start, 'years') + 1 }, (_, i) =>
      start.clone().add(i, 'years'))
    return years.map(year => year.year())
  }

  public get hasEnded() {
    // return true if the opportunity has ended
    return moment().isAfter(this._opportunity.end_at)
  }

  public get apiData() {
    return {
      id: this.id,
      opportunity_id: this.opportunity_id,
      closed_at: this.closed_at,
      amount: this.amount,
      status: this.status,
      revenue_details: this.revenue_details,
      delete_on_save: this.delete_on_save,
    }
  }

  public readOpportunity(opportunity: Opportunity) {
    this._opportunity = opportunity
  }

  public deleteLater() {
    this.delete_on_save = true
  }
}
